import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imagens/logoCompleta.png'
import _imports_1 from '@/assets/imagens/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-89665a5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-custom topnav-navbar" }
const _hoisted_2 = { class: "topbar container-fluid" }
const _hoisted_3 = { class: "d-flex align-items-center gap-lg-2 gap-1" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"logo-topbar\" data-v-89665a5c><span class=\"logo-lg\" data-v-89665a5c><img src=\"" + _imports_0 + "\" alt=\"logo\" height=\"50\" width=\"130\" data-v-89665a5c></span><span class=\"logo-sm\" data-v-89665a5c><img src=\"" + _imports_1 + "\" alt=\"small logo\" height=\"22\" data-v-89665a5c></span></div><button class=\"button-toggle-menu\" data-v-89665a5c><i class=\"mdi mdi-menu\" data-v-89665a5c></i></button>", 2)
const _hoisted_6 = {
  class: "navbar-toggle",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#topnav-menu-content"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lines" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "navbar-toggle" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "topbar-menu d-flex align-items-center gap-3" }
const _hoisted_15 = { class: "notification-list d-sm-inline-block" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-moon-line font-22" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "dropdown notification-list loginPC",
  id: "nomeFuncao"
}
const _hoisted_19 = {
  class: "nav-link dropdown-toggle nav-user nav-usuario arrow-none me-0",
  "data-bs-toggle": "dropdown",
  href: "#",
  role: "button",
  "aria-haspopup": "false",
  "aria-expanded": "false"
}
const _hoisted_20 = { class: "nomeFuncao" }
const _hoisted_21 = { class: "account-user-name" }
const _hoisted_22 = { class: "account-position" }
const _hoisted_23 = { class: "dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-logout-box-fill me-1" }, null, -1))
const _hoisted_25 = {
  key: 1,
  class: "dropdown notification-list"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "nav-link dropdown-toggle nav-user nav-usuario arrow-none me-0 pe-none" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "account-user-name" }),
    /*#__PURE__*/_createElementVNode("span", { class: "account-position" }, "Por favor, faça login")
  ])
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "loginCelular" }
const _hoisted_29 = { class: "topbar-menu d-flex align-items-center gap-3" }
const _hoisted_30 = {
  key: 0,
  class: "dropdown notification-list",
  id: "nomeFuncao"
}
const _hoisted_31 = {
  class: "nav-link dropdown-toggle nav-user nav-usuario arrow-none me-0",
  "data-bs-toggle": "dropdown",
  href: "#",
  role: "button",
  "aria-haspopup": "false",
  "aria-expanded": "false"
}
const _hoisted_32 = { class: "nomeFuncao" }
const _hoisted_33 = { class: "account-user-name" }
const _hoisted_34 = { class: "account-position" }
const _hoisted_35 = { class: "dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-logout-box-fill me-1" }, null, -1))
const _hoisted_37 = {
  key: 1,
  class: "dropdown notification-list"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "nav-link dropdown-toggle nav-user nav-usuario arrow-none me-0 pe-none" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "account-user-name" }),
    /*#__PURE__*/_createElementVNode("span", { class: "account-position" }, "Por favor, faça login")
  ])
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "container-fluid" }
const _hoisted_41 = { class: "navbar navbar-light navbar-expand-lg topnav-menu" }
const _hoisted_42 = {
  class: "collapse navbar-collapse",
  id: "topnav-menu-content"
}
const _hoisted_43 = { class: "navbar-nav" }
const _hoisted_44 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_45 = { class: "btn btn-nav" }
const _hoisted_46 = {
  "data-bs-toggle": "collapse",
  "data-bs-target": "#topnav-menu-content"
}
const _hoisted_47 = {
  key: 1,
  class: "nav-item dropdown"
}
const _hoisted_48 = { class: "btn btn-nav" }
const _hoisted_49 = {
  "data-bs-toggle": "collapse",
  "data-bs-target": "#topnav-menu-content"
}

import { TipoMensagem } from '@/consts/consts';
import mensagem from '@/hooks/mensagem';
import Config from '@/model/Config';
import Perfil from '@/model/Perfil';
import Profissional from '@/model/Profissional';
import Usuario from '@/model/Usuario';
import services from '@/services';
import { store } from '@/store';
import { computed, onMounted, reactive } from 'vue';
import ModalDorape from './ModalDorape.vue';
import EscolherTela from './EscolherTela.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: ['retornaPossuiPermissao'],
  emits: ['trocarTema'],
  setup(__props, { emit: emits }) {

const props = __props;




const state = reactive({
    username: String(),
    funcao: String(),
    // @ts-expect-error : unreachable code
    theme: window.config.theme,
    telaPequena: true,
    config: Object() as Config,
    profissional: Object() as Profissional,
    modalSelecaoTelaVisivel: Boolean(),
});

function deslogar() {
    sessionStorage.removeItem("TokenProntuarioWeb");
    sessionStorage.removeItem("funcao");
    sessionStorage.removeItem("nome");
    location.reload();
}

function tema() {
    let html = document.querySelector("html");
    (state.theme == 'light') ? state.theme = "dark" : state.theme = "light";
    html?.setAttribute('data-theme', state.theme);
    html?.setAttribute('data-bs-theme', state.theme);
    html?.setAttribute('data-topbar-color', state.theme);
    html?.setAttribute('data-menu-color', state.theme);
    let tema = JSON.parse(String(window.sessionStorage.getItem("__HYPER_CONFIG__")));
    // console.log(tema);
    tema.theme = state.theme;
    tema.menu.color = state.theme;
    tema.topbar.color = state.theme;
    window.sessionStorage.setItem("__HYPER_CONFIG__", JSON.stringify(tema));

    emits("trocarTema", state.theme);
}

function login() {
    state.username = usuario.value?.nome;
    state.funcao = usuario.value?.funcao;
}

function tamanho() {
    setInterval(() => {
        // (window.innerWidth <= 992) ? state.telaPequena = true : state.telaPequena = false;
        (window.innerWidth <= 1023) ? state.telaPequena = true : state.telaPequena = false;
    }, 100);
}

function abrirModalSelecaoTela() {
    state.modalSelecaoTelaVisivel = true;
}

function fecharModal() {
    state.modalSelecaoTelaVisivel = false;
}

const usuario = computed(() => {
    return store.getters.getUsuario;
});

const token = computed(() => {
    return store.getters.getToken;
});

onMounted(async () => {
    if (sessionStorage.getItem('TokenProntuarioWeb')) {
        tamanho();
        const msg = mensagem();
        let usuario = Object() as Usuario;
        let perfil = Object() as Perfil;
        let sql = `
                SELECT U.ID, U.NOME NOME_USUARIO, U.ATIVO, U.LOGIN, U.FUNCAO, P.ID ID_PERFIL, P.DESCRICAO DESC_PERFIL, PR.ID ID_PROF FROM USUARIO U
                INNER JOIN PERFIL P ON U.ID_PERFIL = P.ID 
                left JOIN PROFISSIONAL PR ON PR.ID_USUARIO = U.ID
                WHERE U.NOME = '${sessionStorage.getItem('nome')}' AND U.FUNCAO = '${sessionStorage.getItem('funcao')}'
                `;
        let { data, erros } = await services.config.Listar();
        if (!erros) {
            store.commit('setConfig', data);
        } else {
            msg.InserirMensagem('Erro', erros.statusText, TipoMensagem.Error);
        }

        data = await services.relatorio.ListarSql(sql);
        if (!data.erros) {
            // console.log(data.data);
            // usuario.id = data.data[0][0];
            usuario.nome = data.data[0][1];
            // usuario.ativo = data.data[0][2];
            usuario.login = data.data[0][3];
            usuario.funcao = data.data[0][4];
            // perfil.id = data.data[0][5];
            perfil.descricao = data.data[0][6];
            if (data.data[0][7]) {
                state.profissional.nome = data.data[0][1];
                state.profissional.id = data.data[0][7];
                store.commit('setProfissional', state.profissional);
            }
            usuario.perfil = perfil;
            store.commit('setUsuario', usuario);
            store.commit('setToken', sessionStorage.getItem('TokenProntuarioWeb'));
        } else {
            msg.InserirMensagem('Erro', data.erros.statusText, TipoMensagem.Error);
        }

        data = await services.config.Listar();

        if (!data.erros) {
            state.config = data.data;
        }

        // let html = document.querySelector("html");
        // html?.setAttribute('data-theme', 'dark');
        // html?.setAttribute('data-topbar-color', 'dark');
        // html?.setAttribute('data-bs-theme', 'dark');
        // html?.setAttribute('data-menu-color', 'dark');

        login();
    }
    // console.log(document.querySelector('#nomeFuncao')?.offsetWidth);
    // console.log(document.querySelector('#nomeFuncao')?.offsetHeight);
    if (localStorage.getItem('iniciar') == 'true' && window.innerWidth <= 1023) {
        state.modalSelecaoTelaVisivel = true;
        localStorage.setItem('iniciar', String(false));
    }
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("button", _hoisted_6, _hoisted_8, 512), [
            [_vShow, _unref(token) && state.telaPequena == false]
          ]),
          _withDirectives(_createElementVNode("button", _hoisted_9, [
            _createElementVNode("div", {
              class: "lines",
              onClick: abrirModalSelecaoTela
            }, _hoisted_13)
          ], 512), [
            [_vShow, _unref(token) && state.telaPequena == true]
          ])
        ]),
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("a", {
              class: "nav-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tema())),
              id: "light-dark-mode"
            }, _hoisted_17)
          ]),
          (_unref(token))
            ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                _createElementVNode("a", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(state.username), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(state.funcao), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (_unref(token))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "dropdown-item notify-item m-0 my-1",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (deslogar()))
                      }, [
                        _hoisted_24,
                        _createTextVNode(" Deslogar ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_25, _hoisted_27))
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("ul", _hoisted_29, [
          (_unref(token))
            ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                _createElementVNode("a", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(state.username), 1),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(state.funcao), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  (_unref(token))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "dropdown-item notify-item m-0 my-1",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (deslogar()))
                      }, [
                        _hoisted_36,
                        _createTextVNode(" Deslogar ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_37, _hoisted_39))
        ])
      ])
    ]),
    (state.modalSelecaoTelaVisivel)
      ? (_openBlock(), _createBlock(EscolherTela, {
          key: 0,
          modalSelecaoTelaVisivel: state.modalSelecaoTelaVisivel,
          onFecharSelecaoTela: fecharModal
        }, null, 8, ["modalSelecaoTelaVisivel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["topnav topnav-light shadow-sm", { 'mb-2': _unref(token) }])
    }, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("nav", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("ul", _hoisted_43, [
              (_unref(token) && state.config.usarAgenda)
                ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                    _createElementVNode("button", _hoisted_45, [
                      _createVNode(_component_RouterLink, {
                        to: "/agenda",
                        class: "nav-link links"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("span", _hoisted_46, " Agenda ", 512), [
                            [_vShow, state.telaPequena === true]
                          ]),
                          _withDirectives(_createElementVNode("span", null, " Agenda ", 512), [
                            [_vShow, state.telaPequena === false]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(token))
                ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                    _createElementVNode("button", _hoisted_48, [
                      _createVNode(_component_RouterLink, {
                        to: "/prontuario",
                        class: "nav-link links"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("span", _hoisted_49, " Prontuário ", 512), [
                            [_vShow, state.telaPequena === true]
                          ]),
                          _withDirectives(_createElementVNode("span", null, " Prontuário ", 512), [
                            [_vShow, state.telaPequena === false]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}
}

})